module.exports = __webpack_public_path__ + "img/icon_classify06.e1efb6c5.png";